// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const AutomationsHttpGetAutomations =
  'AutomationsHttpGetAutomations' as const;
export const AutomationsHttpPostAutomations =
  'AutomationsHttpPostAutomations' as const;
export const AutomationsHttpDeleteAutomationsByAutomationId =
  'AutomationsHttpDeleteAutomationsByAutomationId' as const;
export const AutomationsHttpGetAutomationsByAutomationId =
  'AutomationsHttpGetAutomationsByAutomationId' as const;
export const AutomationsHttpPatchAutomationsByAutomationId =
  'AutomationsHttpPatchAutomationsByAutomationId' as const;
export const AutomationsHttpPutAutomationsByAutomationId =
  'AutomationsHttpPutAutomationsByAutomationId' as const;
export const AutomationsHttpPostAutomationsByAutomationIdHistory =
  'AutomationsHttpPostAutomationsByAutomationIdHistory' as const;
export const AutomationsHttpDeleteAutomationsByAutomationIdHistoryByObjectTypeByObjectIdByVersionId =
  'AutomationsHttpDeleteAutomationsByAutomationIdHistoryByObjectTypeByObjectIdByVersionId' as const;
export const AutomationsHttpGetAutomationsByAutomationIdHistoryByObjectTypeByObjectIdByVersionId =
  'AutomationsHttpGetAutomationsByAutomationIdHistoryByObjectTypeByObjectIdByVersionId' as const;
export const AutomationsHttpPostAutomationsByAutomationIdRuns =
  'AutomationsHttpPostAutomationsByAutomationIdRuns' as const;
export const AutomationsHttpGetAutomationsByAutomationIdRunsEstimate =
  'AutomationsHttpGetAutomationsByAutomationIdRunsEstimate' as const;

/**
 * Original schema `ACLUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ACLUpdateSchema}
 */
export interface AutomationsACLUpdateSchema {
  group_ids?: string[] | null;
  mode: 'APPEND' | 'OVERWRITE';
  permissions: ('read' | 'delete' | 'change-acl' | 'write')[];
  user_ids?: string[] | null;
}
/**
 * Original schema `AIMetadataFillingActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AIMetadataFillingActionParameters}
 */
export interface AutomationsAIMetadataFillingActionParameters {
  field_names?: string[] | null;
  metadata_view_id: string;
  overwrite: boolean;
}
/**
 * Original schema `AIMetadataFillingActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AIMetadataFillingActionSchema}
 */
export interface AutomationsAIMetadataFillingActionSchema {
  parameters: AutomationsAIMetadataFillingActionParameters;
  type: 'AI_METADATA_FILLING';
}
/**
 * Original schema `AddToCollectionActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AddToCollectionActionParameters}
 */
export interface AutomationsAddToCollectionActionParameters {
  collection_id: string;
  index_immediately?: boolean;
}
/**
 * Original schema `AddToCollectionActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AddToCollectionActionSchema}
 */
export interface AutomationsAddToCollectionActionSchema {
  parameters: AutomationsAddToCollectionActionParameters;
  type: 'ADD_TO_COLLECTION';
}
/**
 * Original schema `AnalyzeActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AnalyzeActionParameters}
 */
export interface AutomationsAnalyzeActionParameters {
  force?: boolean;
  force_type?: ('OVERWRITE' | 'APPEND') | null;
}
/**
 * Original schema `AnalyzeActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AnalyzeActionSchema}
 */
export interface AutomationsAnalyzeActionSchema {
  parameters: AutomationsAnalyzeActionParameters;
  type: 'ANALYZE';
}
/**
 * Original schema `ArchiveActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ArchiveActionParameters}
 */
export interface AutomationsArchiveActionParameters {
  allow_duplicate_transfers?: boolean;
  allow_host_transfer?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  destination_storage_id: string;
  keep_collection_structure?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ArchiveActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ArchiveActionSchema}
 */
export interface AutomationsArchiveActionSchema {
  parameters: AutomationsArchiveActionParameters;
  type: 'ARCHIVE';
}
/**
 * Original schema `AssetArchivedTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetArchivedTriggerParameters}
 */
export interface AutomationsAssetArchivedTriggerParameters {
  storage_id?: string;
}
/**
 * Original schema `AssetArchivedTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetArchivedTriggerSchema}
 */
export interface AutomationsAssetArchivedTriggerSchema {
  parameters: AutomationsAssetArchivedTriggerParameters;
  type: 'ARCHIVE';
}
/**
 * Original schema `AssetOnlineTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetOnlineTriggerParameters}
 */
export interface AutomationsAssetOnlineTriggerParameters {
  only_first_version: true;
  wait_for_transcode: boolean;
}
/**
 * Original schema `AssetOnlineTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetOnlineTriggerSchema}
 */
export interface AutomationsAssetOnlineTriggerSchema {
  parameters: AutomationsAssetOnlineTriggerParameters;
  type: 'ASSET_ONLINE';
}
/**
 * Original schema `AssetRestoredTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetRestoredTriggerParameters}
 */
export interface AutomationsAssetRestoredTriggerParameters {
  storage_id?: string;
}
/**
 * Original schema `AssetRestoredTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetRestoredTriggerSchema}
 */
export interface AutomationsAssetRestoredTriggerSchema {
  parameters: AutomationsAssetRestoredTriggerParameters;
  type: 'RESTORE';
}
/**
 * Original schema `AssetSharedTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetSharedTriggerParameters}
 */
export interface AutomationsAssetSharedTriggerParameters {
  allow_download?: boolean | null;
}
/**
 * Original schema `AssetSharedTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetSharedTriggerSchema}
 */
export interface AutomationsAssetSharedTriggerSchema {
  parameters: AutomationsAssetSharedTriggerParameters;
  type: 'ASSET_SHARE';
}
/**
 * Original schema `AssetTransferredToStorageParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetTransferredToStorageParameters}
 */
export interface AutomationsAssetTransferredToStorageParameters {
  format?: string | null;
  storage_id: string;
}
/**
 * Original schema `AssetTransferredToStorageTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AssetTransferredToStorageTriggerSchema}
 */
export interface AutomationsAssetTransferredToStorageTriggerSchema {
  parameters: AutomationsAssetTransferredToStorageParameters;
  type: 'TRANSFER_TO_STORAGE';
}
/**
 * Original schema `AutomationHistorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationHistorySchema}
 */
export interface AutomationsAutomationHistorySchema {
  automation_id: string;
  date_executed?: string;
  error_message?: string;
  job_id?: string;
  object_id: string;
  object_type: string;
  status: 'SUCCEED' | 'FAILED';
  system_domain_id: string;
  version_id: string;
}
/**
 * Original schema `AutomationInternalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationInternalSchema}
 */
export interface AutomationsAutomationInternalSchema {
  actions: (
    | AutomationsAnalyzeActionSchema
    | AutomationsExtractFacesAction
    | AutomationsCreatePublicationJobAction
    | AutomationsArchiveActionSchema
    | AutomationsRestoreAction
    | AutomationsExportAction
    | AutomationsUpdateACLAction
    | AutomationsMetadataUpdateAction
    | AutomationsAIMetadataFillingActionSchema
    | AutomationsTranscodeAction
    | AutomationsTransferAction
    | AutomationsRequestOriginalAction
    | AutomationsAddToCollectionActionSchema
    | AutomationsTranscribeAction
    | AutomationsCreateShareAction
    | AutomationsDeleteAction
    | AutomationsDeleteFileSetAction
    | AutomationsRestrictAssetAction
    | AutomationsRemoveAssetRestrictionAction
    | AutomationsRequestReviewAction
    | AutomationsTriggerCustomAction
  )[];
  conditions?: AutomationsCondition[];
  created_by?: string;
  date_created?: string;
  date_modified?: string;
  description?: string;
  id?: string;
  modified_by?: string;
  name: string;
  status?: 'ACTIVE' | 'INACTIVE';
  system_domain_id?: string;
  triggers: AutomationsTrigger[];
}
/**
 * Original schema `ExtractFacesAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ExtractFacesAction}
 */
export interface AutomationsExtractFacesAction {
  parameters: AutomationsExtractFacesParameters;
  type: 'EXTRACT_FACES';
}
/**
 * Original schema `ExtractFacesParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ExtractFacesParameters}
 */
export interface AutomationsExtractFacesParameters {
  face_image_analysis_profile_id?: string | null;
  face_video_analysis_profile_id?: string | null;
  force?: boolean;
}
/**
 * Original schema `CreatePublicationJobAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreatePublicationJobAction}
 */
export interface AutomationsCreatePublicationJobAction {
  parameters: AutomationsCreatePublicationJobParameters;
  type: 'CREATE_PUBLICATION_JOB';
}
/**
 * Original schema `CreatePublicationJobParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreatePublicationJobParameters}
 */
export interface AutomationsCreatePublicationJobParameters {
  allow_transfer?: boolean;
  metadata_overrides?: {
    [k: string]: unknown;
  };
  storage_id?: string | null;
  template: AutomationsCreatePublicationTemplate;
  thumbnail?: AutomationsCreatePublicationJobThumbnailKeyframe | null;
  title?: string;
  user_id: string;
}
/**
 * Original schema `CreatePublicationTemplate`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreatePublicationTemplate}
 */
export interface AutomationsCreatePublicationTemplate {
  data?: {
    [k: string]: unknown;
  };
  id: string;
}
/**
 * Original schema `CreatePublicationJobThumbnailKeyframe`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreatePublicationJobThumbnailKeyframe}
 */
export interface AutomationsCreatePublicationJobThumbnailKeyframe {
  asset_id: string;
  keyframe_id: string;
  type: 'KEYFRAME';
}
/**
 * Original schema `RestoreAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RestoreAction}
 */
export interface AutomationsRestoreAction {
  parameters: AutomationsRestoreActionParameters;
  type: 'RESTORE';
}
/**
 * Original schema `RestoreActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RestoreActionParameters}
 */
export interface AutomationsRestoreActionParameters {
  allow_duplicate_transfers?: boolean;
  allow_host_transfer?: boolean;
  delete_only_from_source_folder?: boolean;
  delete_original?: boolean;
  destination_directory_path?: string | null;
  destination_storage_id: string;
  keep_collection_structure?: boolean;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `ExportAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ExportAction}
 */
export interface AutomationsExportAction {
  parameters: AutomationsExportActionParameters;
  type: 'EXPORT';
}
/**
 * Original schema `ExportActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ExportActionParameters}
 */
export interface AutomationsExportActionParameters {
  export_location_id: string;
  export_metadata?: boolean | null;
  export_to_asset_folder?: boolean | null;
  file_name?: string | null;
  format_id?: string | null;
  metadata_format?: ('CSV' | 'JSON' | 'XML') | null;
  metadata_view?: string | null;
  overwrite?: boolean | null;
  preferred_original_storage_id?: string | null;
  transcode_profile_ids?: string[] | null;
}
/**
 * Original schema `UpdateACLAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-UpdateACLAction}
 */
export interface AutomationsUpdateACLAction {
  parameters: AutomationsUpdateACLActionParameters;
  type: 'UPDATE_ACL';
}
/**
 * Original schema `UpdateACLActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-UpdateACLActionParameters}
 */
export interface AutomationsUpdateACLActionParameters {
  objects: AutomationsACLUpdateSchema[];
}
/**
 * Original schema `MetadataUpdateAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-MetadataUpdateAction}
 */
export interface AutomationsMetadataUpdateAction {
  parameters: AutomationsMetadataUpdateActionParameters;
  type: 'METADATA_UPDATE';
}
/**
 * Original schema `MetadataUpdateActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-MetadataUpdateActionParameters}
 */
export interface AutomationsMetadataUpdateActionParameters {
  metadata_values: {
    [k: string]: AutomationsMetadataFieldValueUpdateSchema;
  };
  metadata_view_id: string;
}
/**
 * Original schema `MetadataFieldValueUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-MetadataFieldValueUpdateSchema}
 */
export interface AutomationsMetadataFieldValueUpdateSchema {
  field_values?: {
    [k: string]: string | number | boolean;
  }[];
  mode?: 'append' | 'delete' | 'overwrite';
}
/**
 * Original schema `TranscodeAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TranscodeAction}
 */
export interface AutomationsTranscodeAction {
  parameters: AutomationsTranscodeActionParameters;
  type: 'TRANSCODE';
}
/**
 * Original schema `TranscodeActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TranscodeActionParameters}
 */
export interface AutomationsTranscodeActionParameters {
  format_name?: string;
  prefer_any_cloud?: boolean;
  preferred_storage_id?: string;
  preferred_storage_method?:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE';
  priority?: number;
}
/**
 * Original schema `TransferAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TransferAction}
 */
export interface AutomationsTransferAction {
  parameters: AutomationsTransferActionParameters;
  type: 'TRANSFER';
}
/**
 * Original schema `TransferActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TransferActionParameters}
 */
export interface AutomationsTransferActionParameters {
  allow_host_transfer?: boolean;
  destination_directory_path?: string | null;
  destination_storage_id: string;
  format_name: string;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `RequestOriginalAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RequestOriginalAction}
 */
export interface AutomationsRequestOriginalAction {
  parameters: AutomationsTransferActionParameters;
  type: 'REQUEST_ORIGINAL';
}
/**
 * Original schema `TranscribeAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TranscribeAction}
 */
export interface AutomationsTranscribeAction {
  parameters: AutomationsTranscribeActionParameters;
  type: 'TRANSCRIBE';
}
/**
 * Original schema `TranscribeActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TranscribeActionParameters}
 */
export interface AutomationsTranscribeActionParameters {
  engine?: string | null;
  force?: boolean;
  language?: string | null;
  speakers?: number | null;
  summary?: boolean | null;
  topics_extraction?: boolean;
  translate_languages?: string[] | null;
}
/**
 * Original schema `CreateShareAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreateShareAction}
 */
export interface AutomationsCreateShareAction {
  parameters: AutomationsCreateShareActionParameters;
  type: 'CREATE_SHARE';
}
/**
 * Original schema `CreateShareActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreateShareActionParameters}
 */
export interface AutomationsCreateShareActionParameters {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  emails: string[];
  expires_in_days?: number | null;
  has_password?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata_views?: string[] | null;
  password?: string | null;
  show_watermark?: boolean;
  title?: string;
  upload_storage_id?: string | null;
  user_id: string;
}
/**
 * Original schema `DeleteAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-DeleteAction}
 */
export interface AutomationsDeleteAction {
  parameters?: {
    [k: string]: unknown;
  };
  type: 'DELETE_ASSET';
}
/**
 * Original schema `DeleteFileSetAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-DeleteFileSetAction}
 */
export interface AutomationsDeleteFileSetAction {
  parameters: AutomationsDeleteFileSetActionParameters;
  type: 'DELETE_FILE_SET';
}
/**
 * Original schema `DeleteFileSetActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-DeleteFileSetActionParameters}
 */
export interface AutomationsDeleteFileSetActionParameters {
  format: string;
  storage_id: string;
}
/**
 * Original schema `RestrictAssetAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RestrictAssetAction}
 */
export interface AutomationsRestrictAssetAction {
  parameters: AutomationsRestrictAssetActionParameters;
  type: 'RESTRICT_ASSET';
}
/**
 * Original schema `RestrictAssetActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RestrictAssetActionParameters}
 */
export interface AutomationsRestrictAssetActionParameters {
  restrict_metadata_field: string;
  warning?: string;
  warning_metadata_field?: string;
}
/**
 * Original schema `RemoveAssetRestrictionAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RemoveAssetRestrictionAction}
 */
export interface AutomationsRemoveAssetRestrictionAction {
  parameters: AutomationsRemoveAssetRestrictionActionParameters;
  type: 'REMOVE_ASSET_RESTRICTION';
}
/**
 * Original schema `RemoveAssetRestrictionActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RemoveAssetRestrictionActionParameters}
 */
export interface AutomationsRemoveAssetRestrictionActionParameters {
  restrict_metadata_field: string;
  warning_metadata_field?: string;
}
/**
 * Original schema `RequestReviewAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RequestReviewAction}
 */
export interface AutomationsRequestReviewAction {
  parameters: AutomationsRequestReviewActionParameters;
  type: 'REQUEST_REVIEW';
}
/**
 * Original schema `RequestReviewActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RequestReviewActionParameters}
 */
export interface AutomationsRequestReviewActionParameters {
  externals?: string[];
  groups?: string[];
  min_number?: number;
  share: AutomationsCreateShareActionParameters;
  status?: 'N/A' | 'REQUESTED' | 'APPROVED' | 'NOT_APPROVED' | 'MIXED';
  users?: string[];
}
/**
 * Original schema `TriggerCustomAction`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TriggerCustomAction}
 */
export interface AutomationsTriggerCustomAction {
  parameters: AutomationsTriggerCustomActionParameters;
  type: 'CUSTOM_ACTION';
}
/**
 * Original schema `TriggerCustomActionParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TriggerCustomActionParameters}
 */
export interface AutomationsTriggerCustomActionParameters {
  action_id: string;
  context: 'ASSET' | 'ASSET_SUBCLIP' | 'BULK';
  metadata_values?: {
    [k: string]: AutomationsMetadataFieldValueSchema;
  };
}
/**
 * Original schema `MetadataFieldValueSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-MetadataFieldValueSchema}
 */
export interface AutomationsMetadataFieldValueSchema {
  field_values?: {
    [k: string]: string | number | boolean;
  }[];
}
/**
 * Original schema `Condition`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-Condition}
 */
export interface AutomationsCondition {
  conditions?: AutomationsCondition[];
  filters?: AutomationsCondition[];
  operator: string;
  path?: string;
  terms?: AutomationsTerm[];
}
/**
 * Original schema `Term`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-Term}
 */
export interface AutomationsTerm {
  exists?: boolean;
  external?: {
    [k: string]: unknown;
  };
  missing?: boolean;
  name: string;
  range?: AutomationsRangeFilter;
  value?: unknown;
  value_in?: string[];
}
/**
 * Original schema `RangeFilter`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RangeFilter}
 */
export interface AutomationsRangeFilter {
  max?: string;
  min?: string;
  /**
   * Format: +02:00. Results returned in UTC by default
   */
  timezone?: string;
}
/**
 * Original schema `Trigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-Trigger}
 */
export interface AutomationsTrigger {
  date_created?: string;
  date_modified?: string;
  event_type: 'ASSETS' | 'COLLECTIONS';
  execute_at?: string;
  filters?: AutomationsCondition[];
  object_id?: string | null;
  /**
   * @minItems 1
   */
  operations?: ('CREATE' | 'UPDATE' | 'DELETE' | 'SHARE' | 'DELAYED_TRIGGER')[];
  realm?: 'ENTITY' | 'METADATA' | 'FORMATS' | 'FILES' | 'SHARES' | 'JOBS';
  type:
    | 'METADATA_UPDATE'
    | 'ASSET_SHARE'
    | 'TRANSFER_TO_STORAGE'
    | 'MODIFIED_AT_TRANSITION'
    | 'CREATED_AT_TRANSITION'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'ASSET_ONLINE';
}
/**
 * Original schema `AutomationRunEstimateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationRunEstimateSchema}
 */
export interface AutomationsAutomationRunEstimateSchema {
  errors?: string[];
  facets?: {
    [k: string]: AutomationsFacetSchema;
  };
  total?: number;
}
/**
 * Original schema `FacetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-FacetSchema}
 */
export interface AutomationsFacetSchema {
  buckets?: AutomationsBucketSchema[];
  doc_count_error_upper_bound?: number;
  sum_other_doc_count?: number;
}
/**
 * Original schema `BucketSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-BucketSchema}
 */
export interface AutomationsBucketSchema {
  doc_count?: number;
  key?: string;
}
/**
 * Original schema `AutomationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationSchema}
 */
export interface AutomationsAutomationSchema {
  /**
   * @minItems 1
   * @maxItems 1
   */
  actions: (
    | AutomationsAnalyzeActionSchema
    | AutomationsExtractFacesAction
    | AutomationsCreatePublicationJobAction
    | AutomationsArchiveActionSchema
    | AutomationsRestoreAction
    | AutomationsExportAction
    | AutomationsUpdateACLAction
    | AutomationsMetadataUpdateAction
    | AutomationsAIMetadataFillingActionSchema
    | AutomationsTranscodeAction
    | AutomationsTransferAction
    | AutomationsRequestOriginalAction
    | AutomationsAddToCollectionActionSchema
    | AutomationsTranscribeAction
    | AutomationsCreateShareAction
    | AutomationsDeleteAction
    | AutomationsDeleteFileSetAction
    | AutomationsRestrictAssetAction
    | AutomationsRemoveAssetRestrictionAction
    | AutomationsRequestReviewAction
    | AutomationsTriggerCustomAction
  )[];
  conditions?: AutomationsCondition[];
  created_by?: string;
  date_created?: string;
  date_modified?: string;
  description?: string;
  id?: string;
  modified_by?: string;
  name: string;
  status?: 'ACTIVE' | 'INACTIVE';
  system_domain_id?: string;
  /**
   * @minItems 1
   * @maxItems 10
   */
  triggers: (
    | AutomationsMetadataUpdateTrigger
    | AutomationsAssetSharedTriggerSchema
    | AutomationsSubtitleAddedTrigger
    | AutomationsReviewStatusChangedTrigger
    | AutomationsAssetOnlineTriggerSchema
    | AutomationsVersionOnlineTrigger
    | AutomationsAssetTransferredToStorageTriggerSchema
    | AutomationsAssetArchivedTriggerSchema
    | AutomationsAssetRestoredTriggerSchema
    | AutomationsCreatedAtTransitionTrigger
    | AutomationsModifiedAtTransitionTrigger
    | AutomationsObjectAddedToCollectionTrigger
    | AutomationsObjectRemovedFromCollectionTrigger
  )[];
}
/**
 * Original schema `MetadataUpdateTrigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-MetadataUpdateTrigger}
 */
export interface AutomationsMetadataUpdateTrigger {
  parameters: AutomationsMetadataUpdateTriggerParameters;
  type: 'METADATA_UPDATE';
}
/**
 * Original schema `MetadataUpdateTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-MetadataUpdateTriggerParameters}
 */
export interface AutomationsMetadataUpdateTriggerParameters {
  event_type: 'ASSETS' | 'COLLECTIONS';
  metadata_values: {
    [k: string]: AutomationsMetadataFieldValueSchema;
  };
}
/**
 * Original schema `SubtitleAddedTrigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-SubtitleAddedTrigger}
 */
export interface AutomationsSubtitleAddedTrigger {
  parameters: AutomationsSubtitleAddedTriggerParameters;
  type: 'SUBTITLE_ADDED';
}
/**
 * Original schema `SubtitleAddedTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-SubtitleAddedTriggerParameters}
 */
export interface AutomationsSubtitleAddedTriggerParameters {
  closed_captions?: boolean | null;
  language?: string | null;
}
/**
 * Original schema `ReviewStatusChangedTrigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ReviewStatusChangedTrigger}
 */
export interface AutomationsReviewStatusChangedTrigger {
  parameters: AutomationsReviewStatusChangedTriggerParameters;
  type: 'REVIEW_STATUS_CHANGED';
}
/**
 * Original schema `ReviewStatusChangedTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ReviewStatusChangedTriggerParameters}
 */
export interface AutomationsReviewStatusChangedTriggerParameters {
  statuses?: ('N/A' | 'REQUESTED' | 'APPROVED' | 'NOT_APPROVED' | 'MIXED')[];
}
/**
 * Original schema `VersionOnlineTrigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-VersionOnlineTrigger}
 */
export interface AutomationsVersionOnlineTrigger {
  parameters: AutomationsVersionOnlineTriggerParameters;
  type: 'VERSION_ONLINE';
}
/**
 * Original schema `VersionOnlineTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-VersionOnlineTriggerParameters}
 */
export interface AutomationsVersionOnlineTriggerParameters {
  only_first_version: false;
  wait_for_transcode: boolean;
}
/**
 * Original schema `CreatedAtTransitionTrigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreatedAtTransitionTrigger}
 */
export interface AutomationsCreatedAtTransitionTrigger {
  parameters: AutomationsCreatedAtTransitionTriggerParameters;
  type: 'CREATED_AT_TRANSITION';
}
/**
 * Original schema `CreatedAtTransitionTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreatedAtTransitionTriggerParameters}
 */
export interface AutomationsCreatedAtTransitionTriggerParameters {
  /**
   * Indicates a number of days passed since an objects was created.
   */
  days_since_created: number;
}
/**
 * Original schema `ModifiedAtTransitionTrigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ModifiedAtTransitionTrigger}
 */
export interface AutomationsModifiedAtTransitionTrigger {
  parameters: AutomationsModifiedAtTransitionTriggerParameters;
  type: 'MODIFIED_AT_TRANSITION';
}
/**
 * Original schema `ModifiedAtTransitionTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ModifiedAtTransitionTriggerParameters}
 */
export interface AutomationsModifiedAtTransitionTriggerParameters {
  /**
   * Indicates a number of days passed since an objects was modified.
   */
  days_since_modified: number;
}
/**
 * Original schema `ObjectAddedToCollectionTrigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ObjectAddedToCollectionTrigger}
 */
export interface AutomationsObjectAddedToCollectionTrigger {
  parameters: Automations_ObjectCollectionTriggerParameters;
  type: 'OBJECT_ADDED_TO_COLLECTION';
}
/**
 * Original schema `_ObjectCollectionTriggerParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-_ObjectCollectionTriggerParameters}
 */
export interface Automations_ObjectCollectionTriggerParameters {
  collection_ids: string[];
  include_subcollections?: boolean;
  object_type: string;
}
/**
 * Original schema `ObjectRemovedFromCollectionTrigger`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ObjectRemovedFromCollectionTrigger}
 */
export interface AutomationsObjectRemovedFromCollectionTrigger {
  parameters: Automations_ObjectCollectionTriggerParameters;
  type: 'OBJECT_REMOVED_FROM_COLLECTION';
}
/**
 * Original schema `AutomationStatsObjectSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationStatsObjectSchema}
 */
export interface AutomationsAutomationStatsObjectSchema {
  name: string;
  system_domain_id: string;
  type: 'GAUGE';
  value: number;
}
/**
 * Original schema `AutomationStatsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationStatsSchema}
 */
export interface AutomationsAutomationStatsSchema {
  objects?: AutomationsAutomationStatsObjectSchema[];
}
/**
 * Original schema `AutomationsInternalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationsInternalSchema}
 */
export interface AutomationsAutomationsInternalSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AutomationsAutomationInternalSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `AutomationsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationsSchema}
 */
export interface AutomationsAutomationsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AutomationsAutomationSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `ConditionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ConditionSchema}
 */
export interface AutomationsConditionSchema {
  conditions?: AutomationsConditionSchema[];
  filters?: AutomationsConditionSchema[];
  operator: string;
  path?: string;
  terms?: AutomationsTerm[];
}
/**
 * Original schema `CreatePublicationJobActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreatePublicationJobActionSchema}
 */
export interface AutomationsCreatePublicationJobActionSchema {
  parameters: AutomationsCreatePublicationJobParameters;
  type: 'CREATE_PUBLICATION_JOB';
}
/**
 * Original schema `CreateShareActionParametersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreateShareActionParametersSchema}
 */
export interface AutomationsCreateShareActionParametersSchema {
  allow_approving_comments: boolean;
  allow_comments: boolean;
  allow_custom_actions?: boolean;
  allow_download: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status: boolean;
  allow_upload?: boolean;
  allow_user_search_for_mentions?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  emails: string[];
  expires_in_days?: number | null;
  has_password?: {
    [k: string]: unknown;
  };
  message?: string;
  metadata_views?: string[] | null;
  password?: string | null;
  show_watermark?: boolean;
  title?: string;
  upload_storage_id?: string | null;
  user_id: string;
}
/**
 * Original schema `CreateShareActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreateShareActionSchema}
 */
export interface AutomationsCreateShareActionSchema {
  parameters: AutomationsCreateShareActionParametersSchema;
  type: 'CREATE_SHARE';
}
/**
 * Original schema `CreatedAtTransitionTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-CreatedAtTransitionTriggerSchema}
 */
export interface AutomationsCreatedAtTransitionTriggerSchema {
  parameters: AutomationsCreatedAtTransitionTriggerParameters;
  type: 'CREATED_AT_TRANSITION';
}
/**
 * Original schema `DeleteActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-DeleteActionSchema}
 */
export interface AutomationsDeleteActionSchema {
  parameters?: {
    [k: string]: unknown;
  };
  type: 'DELETE_ASSET';
}
/**
 * Original schema `DeleteFileSetActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-DeleteFileSetActionSchema}
 */
export interface AutomationsDeleteFileSetActionSchema {
  parameters: AutomationsDeleteFileSetActionParameters;
  type: 'DELETE_FILE_SET';
}
/**
 * Original schema `ExportActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ExportActionSchema}
 */
export interface AutomationsExportActionSchema {
  parameters: AutomationsExportActionParameters;
  type: 'EXPORT';
}
/**
 * Original schema `ExtractFacesActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ExtractFacesActionSchema}
 */
export interface AutomationsExtractFacesActionSchema {
  parameters: AutomationsExtractFacesParameters;
  type: 'EXTRACT_FACES';
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ListObjectsSchema}
 */
export interface AutomationsListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `MetadataUpdateActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-MetadataUpdateActionSchema}
 */
export interface AutomationsMetadataUpdateActionSchema {
  parameters: AutomationsMetadataUpdateActionParameters;
  type: 'METADATA_UPDATE';
}
/**
 * Original schema `MetadataUpdateTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-MetadataUpdateTriggerSchema}
 */
export interface AutomationsMetadataUpdateTriggerSchema {
  parameters: AutomationsMetadataUpdateTriggerParameters;
  type: 'METADATA_UPDATE';
}
/**
 * Original schema `ModifiedAtTransitionTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ModifiedAtTransitionTriggerSchema}
 */
export interface AutomationsModifiedAtTransitionTriggerSchema {
  parameters: AutomationsModifiedAtTransitionTriggerParameters;
  type: 'MODIFIED_AT_TRANSITION';
}
/**
 * Original schema `ObjectAddedToCollectionTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ObjectAddedToCollectionTriggerSchema}
 */
export interface AutomationsObjectAddedToCollectionTriggerSchema {
  parameters: Automations_ObjectCollectionTriggerParameters;
  type: 'OBJECT_ADDED_TO_COLLECTION';
}
/**
 * Original schema `ObjectRemovedFromCollectionTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ObjectRemovedFromCollectionTriggerSchema}
 */
export interface AutomationsObjectRemovedFromCollectionTriggerSchema {
  parameters: Automations_ObjectCollectionTriggerParameters;
  type: 'OBJECT_REMOVED_FROM_COLLECTION';
}
/**
 * Original schema `RangeFilterSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RangeFilterSchema}
 */
export interface AutomationsRangeFilterSchema {
  max?: string;
  min?: string;
  /**
   * Format: +02:00. Results returned in UTC by default
   */
  timezone?: string;
}
/**
 * Original schema `RemoveAssetRestrictionActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RemoveAssetRestrictionActionSchema}
 */
export interface AutomationsRemoveAssetRestrictionActionSchema {
  parameters: AutomationsRemoveAssetRestrictionActionParameters;
  type: 'REMOVE_ASSET_RESTRICTION';
}
/**
 * Original schema `RequestOriginalActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RequestOriginalActionSchema}
 */
export interface AutomationsRequestOriginalActionSchema {
  parameters: AutomationsTransferActionParameters;
  type: 'REQUEST_ORIGINAL';
}
/**
 * Original schema `RequestReviewActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RequestReviewActionSchema}
 */
export interface AutomationsRequestReviewActionSchema {
  parameters: AutomationsRequestReviewActionParameters;
  type: 'REQUEST_REVIEW';
}
/**
 * Original schema `RestoreActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RestoreActionSchema}
 */
export interface AutomationsRestoreActionSchema {
  parameters: AutomationsRestoreActionParameters;
  type: 'RESTORE';
}
/**
 * Original schema `RestrictAssetActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-RestrictAssetActionSchema}
 */
export interface AutomationsRestrictAssetActionSchema {
  parameters: AutomationsRestrictAssetActionParameters;
  type: 'RESTRICT_ASSET';
}
/**
 * Original schema `ReviewStatusChangedTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-ReviewStatusChangedTriggerSchema}
 */
export interface AutomationsReviewStatusChangedTriggerSchema {
  parameters: AutomationsReviewStatusChangedTriggerParameters;
  type: 'REVIEW_STATUS_CHANGED';
}
/**
 * Original schema `SubtitleAddedTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-SubtitleAddedTriggerSchema}
 */
export interface AutomationsSubtitleAddedTriggerSchema {
  parameters: AutomationsSubtitleAddedTriggerParameters;
  type: 'SUBTITLE_ADDED';
}
/**
 * Original schema `TermSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TermSchema}
 */
export interface AutomationsTermSchema {
  exists?: boolean;
  external?: {
    [k: string]: unknown;
  };
  missing?: boolean;
  name: string;
  range?: AutomationsRangeFilterSchema;
  value?: unknown;
  value_in?: string[];
}
/**
 * Original schema `TranscodeActionParametersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TranscodeActionParametersSchema}
 */
export interface AutomationsTranscodeActionParametersSchema {
  format_name?: string;
  prefer_any_cloud?: boolean;
  preferred_storage_id?: string;
  preferred_storage_method?:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'B2'
    | 'GCS'
    | 'PORTAL'
    | 'CUSTOM'
    | 'AZURE';
  priority?: number;
}
/**
 * Original schema `TranscodeActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TranscodeActionSchema}
 */
export interface AutomationsTranscodeActionSchema {
  parameters: AutomationsTranscodeActionParametersSchema;
  type: 'TRANSCODE';
}
/**
 * Original schema `TranscribeActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TranscribeActionSchema}
 */
export interface AutomationsTranscribeActionSchema {
  parameters: AutomationsTranscribeActionParameters;
  type: 'TRANSCRIBE';
}
/**
 * Original schema `TransferActionParametersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TransferActionParametersSchema}
 */
export interface AutomationsTransferActionParametersSchema {
  allow_host_transfer?: boolean;
  destination_directory_path?: string | null;
  destination_storage_id: string;
  format_name: string;
  preferred_original_storage_id?: string | null;
}
/**
 * Original schema `TransferActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TransferActionSchema}
 */
export interface AutomationsTransferActionSchema {
  parameters: AutomationsTransferActionParametersSchema;
  type: 'TRANSFER';
}
/**
 * Original schema `TriggerCustomActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TriggerCustomActionSchema}
 */
export interface AutomationsTriggerCustomActionSchema {
  parameters: AutomationsTriggerCustomActionParameters;
  type: 'CUSTOM_ACTION';
}
/**
 * Original schema `TriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TriggerSchema}
 */
export interface AutomationsTriggerSchema {
  date_created?: string;
  date_modified?: string;
  event_type: 'ASSETS' | 'COLLECTIONS';
  execute_at?: string;
  filters?: AutomationsConditionSchema[];
  object_id?: string | null;
  /**
   * @minItems 1
   */
  operations?: ('CREATE' | 'UPDATE' | 'DELETE' | 'SHARE' | 'DELAYED_TRIGGER')[];
  realm?: 'ENTITY' | 'METADATA' | 'FORMATS' | 'FILES' | 'SHARES' | 'JOBS';
  type:
    | 'METADATA_UPDATE'
    | 'ASSET_SHARE'
    | 'TRANSFER_TO_STORAGE'
    | 'MODIFIED_AT_TRANSITION'
    | 'CREATED_AT_TRANSITION'
    | 'ARCHIVE'
    | 'RESTORE'
    | 'ASSET_ONLINE';
}
/**
 * Original schema `TriggersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-TriggersSchema}
 */
export interface AutomationsTriggersSchema {
  objects?: AutomationsTriggerSchema[];
}
/**
 * Original schema `UpdateACLActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-UpdateACLActionSchema}
 */
export interface AutomationsUpdateACLActionSchema {
  parameters: AutomationsUpdateACLActionParameters;
  type: 'UPDATE_ACL';
}
/**
 * Original schema `VersionOnlineTriggerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-VersionOnlineTriggerSchema}
 */
export interface AutomationsVersionOnlineTriggerSchema {
  parameters: AutomationsVersionOnlineTriggerParameters;
  type: 'VERSION_ONLINE';
}
/**
 * Original schema `_ActionSchemaBase`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-_ActionSchemaBase}
 */
export interface Automations_ActionSchemaBase {
  parameters?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `_ObjectCollectionTriggerParametersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-_ObjectCollectionTriggerParametersSchema}
 */
export interface Automations_ObjectCollectionTriggerParametersSchema {
  collection_ids: string[];
  include_subcollections?: boolean;
  object_type: string;
}
/**
 * Original schema `_TriggerSchemaBase`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-_TriggerSchemaBase}
 */
export interface Automations_TriggerSchemaBase {
  parameters?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `AutomationsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationsSchema}
 */
export interface AutomationsAutomationsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AutomationsAutomationSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `AutomationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationSchema}
 */
export interface AutomationsAutomationSchemaWithIdNullable {
  /**
   * @minItems 1
   * @maxItems 1
   */
  actions: (
    | AutomationsAnalyzeActionSchema
    | AutomationsExtractFacesAction
    | AutomationsCreatePublicationJobAction
    | AutomationsArchiveActionSchema
    | AutomationsRestoreAction
    | AutomationsExportAction
    | AutomationsUpdateACLAction
    | AutomationsMetadataUpdateAction
    | AutomationsAIMetadataFillingActionSchema
    | AutomationsTranscodeAction
    | AutomationsTransferAction
    | AutomationsRequestOriginalAction
    | AutomationsAddToCollectionActionSchema
    | AutomationsTranscribeAction
    | AutomationsCreateShareAction
    | AutomationsDeleteAction
    | AutomationsDeleteFileSetAction
    | AutomationsRestrictAssetAction
    | AutomationsRemoveAssetRestrictionAction
    | AutomationsRequestReviewAction
    | AutomationsTriggerCustomAction
  )[];
  conditions?: AutomationsCondition[] | null;
  created_by?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id: string;
  modified_by?: string | null;
  name: string;
  status?: ('ACTIVE' | 'INACTIVE') | null;
  system_domain_id?: string | null;
  /**
   * @minItems 1
   * @maxItems 10
   */
  triggers: (
    | AutomationsMetadataUpdateTrigger
    | AutomationsAssetSharedTriggerSchema
    | AutomationsSubtitleAddedTrigger
    | AutomationsReviewStatusChangedTrigger
    | AutomationsAssetOnlineTriggerSchema
    | AutomationsVersionOnlineTrigger
    | AutomationsAssetTransferredToStorageTriggerSchema
    | AutomationsAssetArchivedTriggerSchema
    | AutomationsAssetRestoredTriggerSchema
    | AutomationsCreatedAtTransitionTrigger
    | AutomationsModifiedAtTransitionTrigger
    | AutomationsObjectAddedToCollectionTrigger
    | AutomationsObjectRemovedFromCollectionTrigger
  )[];
}
/**
 * Original schema `AutomationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationSchema}
 */
export interface AutomationsAutomationSchemaWithId {
  /**
   * @minItems 1
   * @maxItems 1
   */
  actions: (
    | AutomationsAnalyzeActionSchema
    | AutomationsExtractFacesAction
    | AutomationsCreatePublicationJobAction
    | AutomationsArchiveActionSchema
    | AutomationsRestoreAction
    | AutomationsExportAction
    | AutomationsUpdateACLAction
    | AutomationsMetadataUpdateAction
    | AutomationsAIMetadataFillingActionSchema
    | AutomationsTranscodeAction
    | AutomationsTransferAction
    | AutomationsRequestOriginalAction
    | AutomationsAddToCollectionActionSchema
    | AutomationsTranscribeAction
    | AutomationsCreateShareAction
    | AutomationsDeleteAction
    | AutomationsDeleteFileSetAction
    | AutomationsRestrictAssetAction
    | AutomationsRemoveAssetRestrictionAction
    | AutomationsRequestReviewAction
    | AutomationsTriggerCustomAction
  )[];
  conditions?: AutomationsCondition[];
  created_by?: string;
  date_created?: string;
  date_modified?: string;
  description?: string;
  id: string;
  modified_by?: string;
  name: string;
  status?: 'ACTIVE' | 'INACTIVE';
  system_domain_id?: string;
  /**
   * @minItems 1
   * @maxItems 10
   */
  triggers: (
    | AutomationsMetadataUpdateTrigger
    | AutomationsAssetSharedTriggerSchema
    | AutomationsSubtitleAddedTrigger
    | AutomationsReviewStatusChangedTrigger
    | AutomationsAssetOnlineTriggerSchema
    | AutomationsVersionOnlineTrigger
    | AutomationsAssetTransferredToStorageTriggerSchema
    | AutomationsAssetArchivedTriggerSchema
    | AutomationsAssetRestoredTriggerSchema
    | AutomationsCreatedAtTransitionTrigger
    | AutomationsModifiedAtTransitionTrigger
    | AutomationsObjectAddedToCollectionTrigger
    | AutomationsObjectRemovedFromCollectionTrigger
  )[];
}
/**
 * Original schema `AutomationHistorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationHistorySchema}
 */
export interface AutomationsAutomationHistorySchemaNullable {
  automation_id: string;
  date_executed?: string | null;
  error_message?: string | null;
  job_id?: string | null;
  object_id: string;
  object_type: string;
  status: 'SUCCEED' | 'FAILED';
  system_domain_id: string;
  version_id: string;
}
/**
 * Original schema `AutomationRunEstimateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#model-AutomationRunEstimateSchema}
 */
export interface AutomationsAutomationRunEstimateSchemaNullable {
  errors?: string[] | null;
  facets?: {
    [k: string]: AutomationsFacetSchema;
  } | null;
  total?: number | null;
}

/**
 * `GET /v1/automations/`
 *
 * List of automations
 *
 * Required roles:
 *  - can_read_automations
 *
 * Responses
 * - 200 - Returns a list of automation
 * - 401 - Token is invalid
 *
 * Response {@link AutomationsAutomationsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/get_v1_automations_}
 */
export const httpGetAutomations = (headers?: IconikApiHeaders) => ({
  id: AutomationsHttpGetAutomations,
  method: httpMethod.get,
  url: '/API/automations/v1/automations/',

  headers,
});

/**
 * `POST /v1/automations/`
 *
 * Create a new automation
 *
 * Required roles:
 *  - can_write_automations
 *
 * Responses
 * - 201 - Returns a created automation
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AutomationsAutomationSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/post_v1_automations_}
 */
export const httpPostAutomations = (
  body: AutomationsAutomationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AutomationsHttpPostAutomations,
  method: httpMethod.post,
  url: '/API/automations/v1/automations/',

  body,
  headers,
});

/**
 * `DELETE /v1/automations/{automation_id}/`
 *
 * Delete a particular automation by id
 *
 * Required roles:
 *  - can_delete_automations
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/delete_v1_automations__automation_id__}
 */
export const httpDeleteAutomationsByAutomationId = (
  automationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AutomationsHttpDeleteAutomationsByAutomationId,
  method: httpMethod.delete,
  url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/`,
  params: { automationId },
  headers,
});

/**
 * `GET /v1/automations/{automation_id}/`
 *
 * Returns a particular automation by id
 *
 * Required roles:
 *  - can_read_automations
 *
 * Responses
 * - 200 - Returns an automation
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AutomationsAutomationSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/get_v1_automations__automation_id__}
 */
export const httpGetAutomationsByAutomationId = (
  automationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AutomationsHttpGetAutomationsByAutomationId,
  method: httpMethod.get,
  url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/`,
  params: { automationId },
  headers,
});

export type AutomationsAutomationSchemaPartial =
  Partial<AutomationsAutomationSchema>;

/**
 * `PATCH /v1/automations/{automation_id}/`
 *
 * Update automation
 *
 * Required roles:
 *  - can_write_automations
 *
 * Responses
 * - 200 - Returns an updated automation
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AutomationsAutomationSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/patch_v1_automations__automation_id__}
 */
export const httpPatchAutomationsByAutomationId = (
  automationId: string,
  body: AutomationsAutomationSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AutomationsHttpPatchAutomationsByAutomationId,
  method: httpMethod.patch,
  url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/`,
  params: { automationId },
  body,
  headers,
});

/**
 * `PUT /v1/automations/{automation_id}/`
 *
 * Update automation
 *
 * Required roles:
 *  - can_write_automations
 *
 * Responses
 * - 200 - Returns an updated automation
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AutomationsAutomationSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/put_v1_automations__automation_id__}
 */
export const httpPutAutomationsByAutomationId = (
  automationId: string,
  body: AutomationsAutomationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AutomationsHttpPutAutomationsByAutomationId,
  method: httpMethod.put,
  url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/`,
  params: { automationId },
  body,
  headers,
});

export interface AutomationsHttpPostAutomationsByAutomationIdHistoryQuery {
  ttl?: number;
}

/**
 * `POST /v1/automations/{automation_id}/history/`
 *
 * Create a new history entity
 *
 * Required roles:
 *  - can_write_automations
 *
 * Responses
 * - 201 - Returns a created history entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AutomationsAutomationHistorySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/post_v1_automations__automation_id__history_}
 */
export const httpPostAutomationsByAutomationIdHistory = (
  automationId: string,
  body: AutomationsAutomationHistorySchema,
  query?: AutomationsHttpPostAutomationsByAutomationIdHistoryQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AutomationsHttpPostAutomationsByAutomationIdHistory,
  method: httpMethod.post,
  url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/history/`,
  params: { automationId },
  body,
  query,
  headers,
});

/**
 * `DELETE /v1/automations/{automation_id}/history/{object_type}/{object_id}/{version_id}/`
 *
 * Delete history event
 *
 * Required roles:
 *  - can_read_automations
 *
 * Responses
 * - 204 - Returns a history entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - History entity not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/delete_v1_automations__automation_id__history__object_type___object_id___version_id__}
 */
export const httpDeleteAutomationsByAutomationIdHistoryByObjectTypeByObjectIdByVersionId =
  (
    automationId: string,
    objectType: string,
    objectId: string,
    versionId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AutomationsHttpDeleteAutomationsByAutomationIdHistoryByObjectTypeByObjectIdByVersionId,
    method: httpMethod.delete,
    url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/history/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/${encodeURIComponent(versionId)}/`,
    params: { automationId, objectType, objectId, versionId },
    headers,
  });

/**
 * `GET /v1/automations/{automation_id}/history/{object_type}/{object_id}/{version_id}/`
 *
 * Returns a particular history entity by id
 *
 * Required roles:
 *  - can_read_automations
 *
 * Responses
 * - 200 - Returns a history entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AutomationsAutomationHistorySchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/get_v1_automations__automation_id__history__object_type___object_id___version_id__}
 */
export const httpGetAutomationsByAutomationIdHistoryByObjectTypeByObjectIdByVersionId =
  (
    automationId: string,
    objectType: string,
    objectId: string,
    versionId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: AutomationsHttpGetAutomationsByAutomationIdHistoryByObjectTypeByObjectIdByVersionId,
    method: httpMethod.get,
    url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/history/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/${encodeURIComponent(versionId)}/`,
    params: { automationId, objectType, objectId, versionId },
    headers,
  });

/**
 * `POST /v1/automations/{automation_id}/runs/`
 *
 * Run an automation for existing objects
 *
 * Required roles:
 *  - can_run_automations
 *
 * Responses
 * - 202 - Starts the automation run in a background
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/post_v1_automations__automation_id__runs_}
 */
export const httpPostAutomationsByAutomationIdRuns = (
  automationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AutomationsHttpPostAutomationsByAutomationIdRuns,
  method: httpMethod.post,
  url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/runs/`,
  params: { automationId },
  headers,
});

/**
 * `GET /v1/automations/{automation_id}/runs/estimate/`
 *
 * Get estimated number objects that might be affected by an automation run
 *
 * Required roles:
 *  - can_run_automations
 *
 * Responses
 * - 200 - Returns estimated number objects that might be affected by an automation run
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AutomationsAutomationRunEstimateSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/automations/spec/#/default/get_v1_automations__automation_id__runs_estimate_}
 */
export const httpGetAutomationsByAutomationIdRunsEstimate = (
  automationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AutomationsHttpGetAutomationsByAutomationIdRunsEstimate,
  method: httpMethod.get,
  url: `/API/automations/v1/automations/${encodeURIComponent(automationId)}/runs/estimate/`,
  params: { automationId },
  headers,
});
